import { Autocomplete, Popper, styled, TextField } from "@mui/material";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import React from "react";
import CustomView from "../dataDisplay/CustomView";

export default function CoreAutoComplete(props) {
  const StyledPopper = styled(Popper)({
    [`& .${autocompleteClasses.listbox}`]: {
      background: "white",
    },
  });

  const { value, id, onChange, options, label, ...restProps } = props;

  return props.edit !== false ? (
    <Autocomplete
      {...restProps}
      id={id}
      options={options}
      onChange={(event, val) => {
        onChange(props.id, val);
      }}
      getOptionLabel={(option) => {
        if (typeof option === "string" || typeof option === "number") {
          return options?.find(
            (op) =>
              String(op.value).toLowerCase().trim() ===
              String(value).toLowerCase().trim()
          )?.label;
        } else {
          if (option.label) return option.label;
          else if (option.name) {
            return option.name;
          }
        }
      }}
      isOptionEqualToValue={(option, val) => {
        if (typeof val === "string" || typeof val === "number") {
          if (
            String(val).toLowerCase().trim() ===
              String(option.value).toLowerCase().trim() ||
            String(val).toLowerCase().trim() ===
              String(option.id).toLowerCase().trim() ||
            String(val).toLowerCase().trim() ===
              String(option.label).toLowerCase().trim()
          ) {
            // console.log("true str", option, value);
            return true;
          } else {
            // console.log("false str", option, value);
            return false;
          }
        } else {
          if (val?.value === option.value) {
            // console.log("true OB", option, value);
            return true;
          } else {
            // console.log("false OB", option, value);
            return false;
          }
        }
      }}
      value={value}
      PopperComponent={StyledPopper}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="standard"
          placeholder={props.placeholder}
        />
      )}
    />
  ) : (
    <CustomView
      value={
        props.options?.find(
          (op) =>
            String(op?.value)?.trim()?.toLowerCase() ===
            String(props?.value)?.trim()?.toLowerCase()
        )?.label
      }
      label={props.label}
    />
  );
}
